export default "__VITE_ASSET__2583092c__"